import { Modal, Result } from '@bfe/moly';

import { useI18nContext } from '@/i18n/I18n';

// 失败次数过多，账号锁定提示
const ErrorLimitModal = ({ onClose }: { onClose: () => void }) => {
  const [$t] = useI18nContext();

  return (
    <Modal
      open
      title={null}
      okText={$t('confirm')}
      cancelText={false}
      onOk={onClose}
    >
      <Result
        title={$t('loginErrOverLimit')}
        subTitle={$t('loginErrOverLimitTip')}
        status="warning"
      ></Result>
    </Modal>
  );
};

export default ErrorLimitModal;
